var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.user.person.firstName)+" shops")]),_c('vue-table',{ref:"table",attrs:{"useSearch":true,"dataTable":_vm.shops,"tableFields":_vm.shopsTableFields,"defaultSortOrder":[_vm.sortOrder]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }